import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as has from 'lodash/has';

import * as saveActions from '../+state/saved-model-portfolios/saved-model-portfolios.actions';
import * as subscribeActions from '../+state/subscribed-model-portfolios/subscribed-model-portfolios.actions';

@Injectable()
export class UserDataHandlerService {
	constructor(private store: Store<any>) { }

	public load(userDataJson: any): void {
		this.storeSavedModelPortfolioIdMap(userDataJson);

		this.storeSubscribedModelPortfolioIdMap(userDataJson);
	}

	private storeSubscribedModelPortfolioIdMap(userDataJson: any): void {
		if (has(userDataJson, 'result.resultList.subscribedPreference.children')) {
			const subscribedMappings: Map<string, string> = new Map<string, string>();
			const subscribedPreferenceChildren = userDataJson.result.resultList.subscribedPreference.children;
			subscribedPreferenceChildren.forEach(child => {
				subscribedMappings.set(child.identifier, child.uniqueId);
			});
			this.store.dispatch({
				type: subscribeActions.LOAD_SUBSCRIBED_MAPPINGS,
				subscribedPortfolioMapping: subscribedMappings
			});
		}
	}

	private storeSavedModelPortfolioIdMap(userDataJson: any): void {
		if (has(userDataJson, 'result.resultList.savedPreference.children')) {
			const savedMappings: Map<string, string> = new Map<string, string>();
			const savedPreferenceChildren = userDataJson.result.resultList.savedPreference.children;
			savedPreferenceChildren.forEach(child => {
				savedMappings.set(child.identifier, child.uniqueId);
			});
			this.store.dispatch({ type: saveActions.LOAD_SAVED_MAPPINGS, savedPortfolioMapping: savedMappings });
		}
	}

	public getNewMapping(userDataJson: any, portfolioId: string, index: number = 0): Map<string, string> {
		const newMapping: Map<string, string> = new Map<string, string>();

		if (has(userDataJson, `resultMap.SEARCH_EDIT_RESULTS[0].resultList[${index}].children[0]`)) {
			const uniqueId: string = this.getUniqueId(userDataJson.resultMap.SEARCH_EDIT_RESULTS[0].resultList[index].children, portfolioId);

			if (portfolioId && uniqueId) {
				newMapping.set(portfolioId, uniqueId);
			} else {
				console.warn(`Invalid data returned, portfolioId: ${portfolioId}, uniqueId: ${uniqueId}. Saved/Subscription mapping will not be added!`);
			}
		}

		return newMapping;
	}

	public isDeleteSuccessful(userDataJson: any): boolean {
		if (has(userDataJson, 'success')) {
			return userDataJson.success;
		}

		return false;
	}

	private getUniqueId(childrenJson: any[], portfolioId: string): string {
		const child: any = childrenJson.find(childJson => childJson.identifier === portfolioId);
		return child ? child.uniqueId : undefined;
	}
}
